var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkstationEquip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M30.7,15.2c0,0-0.1,0-0.1,0.1C30.6,15.2,30.6,15.2,30.7,15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M30.4,15.4c0,0-0.1,0-0.1,0C30.3,15.4,30.3,15.4,30.4,15.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M30.9,15C30.9,15,30.9,14.9,30.9,15C30.9,15,30.9,15,30.9,15C30.9,15,30.9,15,30.9,15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M30,15.5C30,15.5,29.9,15.5,30,15.5C29.9,15.5,30,15.5,30,15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M31.1,14.7c0,0,0,0.1-0.1,0.1C31.1,14.7,31.1,14.7,31.1,14.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M31.3,13.7c0,0.1,0,0.2,0,0.3C31.3,13.9,31.3,13.8,31.3,13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M31,13.1c0,0.1,0.1,0.1,0.1,0.2C31.1,13.2,31.1,13.1,31,13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M31.2,14.4c0,0.1,0,0.1-0.1,0.1C31.2,14.5,31.2,14.4,31.2,14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M31.3,14.1c0,0.1,0,0.1,0,0.2C31.3,14.2,31.3,14.1,31.3,14.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M30.7,12.7c0.1,0.1,0.2,0.2,0.2,0.3C30.9,12.9,30.8,12.8,30.7,12.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M31.2,13.4c0,0.1,0,0.1,0.1,0.2C31.2,13.5,31.2,13.5,31.2,13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M16.4,22.1c0.3,0.3,0.8,0.5,1.2,0.5h3.8c0.9,0,1.7-0.8,1.7-1.7c0.1-0.9-0.7-1.7-1.6-1.8c0,0-0.1,0-0.1,0h-3 l-4.5-4.2c-1.2-0.7-2.7-0.2-3.4,1c-0.2,0.4-0.3,0.8-0.3,1.2v8.3c0,1.3,1.1,2.4,2.4,2.5h6.6v7.9c0,0.9,0.8,1.7,1.7,1.7 c0.9,0,1.7-0.8,1.7-1.7v-9.6c0-0.9-0.8-1.7-1.7-1.7H15v-3.6L16.4,22.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M17.7,29.7H9.9c-0.6,0-1.1-0.5-1.1-1.1V15.4c0-0.2-0.2-0.4-0.4-0.4c-0.3,0-0.5,0.1-0.5,0.4v13.2 c0,1.1,0.9,2,2,2h2.8v3.8l-2,1.4c-0.2,0.1-0.3,0.3-0.2,0.5c0,0,0,0.1,0,0.1c0.2,0.2,0.4,0.3,0.7,0.2l1.9-1.4l2,1.4 c0.3,0.1,0.5,0,0.7-0.2c0.1-0.2,0.1-0.4-0.1-0.6c0,0-0.1,0-0.1,0l-2-1.4v-3.8h3.9c0.2,0,0.4-0.3,0.4-0.5 C18,29.9,17.9,29.7,17.7,29.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M12.4,13.5c1.7,0,3-1.3,3-3s-1.3-3-3-3c-1.6,0.1-2.9,1.4-3,3C9.5,12.1,10.8,13.4,12.4,13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M36.7,21.1H24c-0.3,0-0.4,0.2-0.4,0.5v2.2c0,0.2,0.2,0.4,0.4,0.4h9.7v10.2h-5.2c-0.3,0-0.5,0.2-0.5,0.5V37 c0,0.3,0.2,0.5,0.5,0.5h8.2c0.3,0,0.4-0.2,0.4-0.5V21.6C37,21.3,37,21.1,36.7,21.1z M36.2,36.6h-7.3v-1.3h5.3 c0.3,0,0.5-0.2,0.5-0.5V24.2h1.5V36.6z M36.2,23.3h-2.1h-9.7V22h11.8V23.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#A1A1A1",
    points: "24.5,23.3 34.2,23.3 36.2,23.3 36.2,22 24.5,22  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1A1",
    d: "M34.7,34.8c0,0.3-0.2,0.5-0.5,0.5h-5.3v1.3h7.3V24.2h-1.5V34.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M26,18.5l1.2,0.5c0.5,0.2,1-0.1,1.2-0.5l0.8-2.1c0.7,0.1,1.3,0,1.9-0.4v3.7h-0.6c-0.2,0-0.4,0.3-0.4,0.5 c0,0.2,0.2,0.4,0.4,0.4h2.2c0.2,0,0.5-0.2,0.5-0.4c0-0.3-0.2-0.5-0.5-0.5H32v-4.8c0.5-1.1,0.1-2.5-1-3.1L32,9.7C32,9.5,32,9.2,32,9 c-0.1-0.3-0.2-0.5-0.5-0.6l-1.1-0.5c-0.5-0.2-1,0-1.3,0.5l-3.6,8.8C25.2,17.7,25.5,18.3,26,18.5z M31.3,14C31.3,14,31.3,14,31.3,14 C31.3,14.1,31.3,14.1,31.3,14c0,0.2,0,0.2,0,0.3c0,0,0,0.1,0,0.1c0,0,0,0.1-0.1,0.1c0,0,0,0.1-0.1,0.1c0,0,0,0.1-0.1,0.1 c0,0.1-0.1,0.1-0.1,0.2c0,0,0,0,0,0c0,0,0,0-0.1,0c-0.1,0.1-0.1,0.1-0.2,0.2c0,0-0.1,0-0.1,0.1c-0.1,0-0.1,0.1-0.2,0.1 c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.2,0.1c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.4,0l1.2-2.8c0.1,0.1,0.2,0.2,0.2,0.3c0,0,0,0.1,0.1,0.1 c0,0.1,0.1,0.1,0.1,0.2c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0.1,0.2c0,0,0,0.1,0,0.1C31.3,13.8,31.3,13.9,31.3,14z M30,8.8L31,9.3 l-3.6,8.8l-1.2-0.5L30,8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M31.2,13.4c0,0,0-0.1,0-0.1c0-0.1-0.1-0.1-0.1-0.2c0,0,0-0.1-0.1-0.1c-0.1-0.1-0.1-0.2-0.2-0.3l-1.2,2.8 c0.1,0,0.2,0,0.4,0c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.2-0.1c0,0,0.1,0,0.1,0c0.1,0,0.1-0.1,0.2-0.1c0,0,0.1,0,0.1-0.1 c0.1-0.1,0.1-0.1,0.2-0.2c0,0,0,0,0.1-0.1c0,0,0.1-0.1,0.1-0.2c0,0,0-0.1,0.1-0.1c0,0,0-0.1,0.1-0.1c0,0,0-0.1,0.1-0.1 c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.2c0,0,0,0,0,0c0,0,0,0,0-0.1c0-0.1,0-0.2,0-0.3c0,0,0-0.1,0-0.1C31.2,13.5,31.2,13.5,31.2,13.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F9F9F9",
    points: "31,9.3 30,8.8 26.2,17.6 27.5,18.1  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkstationEquip);
export default __webpack_public_path__ + "static/media/workstation_equip.b2b864ffe83f89f3b8a992159d1d19fe.svg";
export { ForwardRef as ReactComponent };